import React from 'react';

import flashLight from '@assets/images/light.png';

import CommonImage from '@components/CommonImage';

const ScanSidebar = () => {
	return (
		<>
			<div className="scan-sidebar shadow-8dp active">
				<div className="scan-sidebar-header">
					<div className="d-flex justify-content-between">
						<p className="semibold-14 reqular-14">Scan</p>
						<CommonImage src="/icons/close.svg" className="cursor-pointer" />
					</div>
				</div>
				<div className="filter-action-content">
					<div className="d-flex justify-content-between align-items-center">
						<div className="select-component w-100">
							<div
								className="click-box click mb-1"
								data-toggle="dropdown"
								aria-haspopup="true"
								aria-expanded="false"
							>
								<p className="regular-14 ">Select brand</p>
								<img src=" /images/chevron_down.svg" alt="" />
							</div>
							<div className="dropdown-box dropdown-menu">
								<div className="m-0 search-filter">
									<div className="with-icon right-icon">
										<input type="text" placeholder="Search" defaultValue />
										<span className="right-icon">
											<img src=" /icons/search.png" alt="" />
										</span>
									</div>
								</div>
								<div className="add-btn">
									<button className="button text">
										<img src=" /icons/add_primary.svg" alt="" />
										<span className="ml-1">Add Item</span>
									</button>
								</div>
								<div className="list-items scroll-y-label">
									<div className="single-item">
										<p>Item 1</p>
									</div>
									<div className="single-item">
										<p>Item 2</p>
									</div>
									<div className="single-item">
										<p>Item 3</p>
									</div>
									<div className="single-item">
										<p>Item 4</p>
									</div>
									<div className="single-item">
										<p>Item 5</p>
									</div>
								</div>
							</div>
						</div>
						<div className="sort-button design-view-sort ml-3">
							<div className="dropdown">
								<button
									className="btn btn-default dropdown-toggle gray_dark_02 regular-14 pl-0 pr-1 mr-0"
									type="button"
									data-toggle="dropdown"
								>
									<CommonImage src="/icons/large-view.svg" className="cursor-pointer" />
								</button>
								<ul className="dropdown-menu dropdown-menu dropdown-menu-right shadow-4dp">
									<li>
										<CommonImage src="/icons/list-view.svg" className="cursor-pointer" />
										list
									</li>
								</ul>
							</div>
						</div>
					</div>
					<div className="filter-actions d-block mt-3">
						<div class="form-group size32 m-0 search-filter filter-with-animation d-flex align-items-center mw-100">
							<div class="right-icon w-100">
								<div class="search-and-dropdown-filter d-flex align-items-center gap-2">
									<input
										type="text"
										autocomplete="off"
										name="name"
										placeholder="Scan QR/Barcode code"
										value=""
										className="border-0"
									/>
									<div class="edit-items search-edit-items">
										<div class="option">
											<div class="dropdown">
												<button
													class="btn btn-default dropdown-toggle d-flex align-items-center gap-2"
													type="button"
													data-toggle="dropdown"
												>
													<CommonImage src="/icons/search-dark.svg" />
													<CommonImage src="/images/chevron_down.svg" />
												</button>
												<ul class="dropdown-menu dropdown-menu-right shadow-lg">
													<li>
														<span class="gray_dark_01 regular-14">
															Search with Design No.
														</span>
													</li>
													<li class="d-flex align-items-center border-top-solid justify-content-between toggle-and-content">
														<span class="gray_dark_01 regular-14">
															Add to favourite
														</span>
														<CommonImage
															src="/icons/toggle-off.svg"
															class="cursor-pointer pr-3"
														/>
													</li>
												</ul>
											</div>
										</div>
									</div>
								</div>
								<span class="right-icon d-flex align-items-center"></span>
							</div>
						</div>
					</div>
				</div>
				<div className="scanner-body scroll-y-label">
					<div className="qr-scanner  d-flex align-items-center justify-content-center flex-column mb-3">
						<div className="close-icon">
							<CommonImage
								src="/icons/close-14.svg"
								width={24}
								height={24}
								className="cursor-pointer"
							/>
						</div>
						<div className="qr-img after-before-content d-flex align-items-center justify-content-center flex-column">
							{/* <img src={qrImage} /> */}
							<span class="qr-border_btm after-before-content"></span>
						</div>
						<div className="scanner-bottom d-flex align-items-center justify-content-between">
							<div className="light-btn">
								<img src={flashLight} width={27} height={27} className="cursor-pointer" />
							</div>
							<div className="zoom-in-out-btn">
								<CommonImage
									src="/icons/add-round.svg"
									className="cursor-pointer add-icon"
									width={24}
									height={24}
								/>
								<CommonImage
									src="/icons/minus-round.svg"
									className="cursor-pointer"
									width={24}
									height={24}
								/>
							</div>
						</div>
						<div className="scanner-overlay"></div>
					</div>
					<div className="scan-list-table">
						<table className="table w-100 no-hover with-border">
							<thead>
								<tr>
									<th>SL NO.</th>
									<th>Scanned output</th>
									<th className="text-center action-column">
										<CommonImage src="/icons/trash.svg" className="cursor-pointer" />
									</th>
								</tr>
							</thead>
							<tbody>
								<tr className="scanned-folder">
									<td>1</td>
									<td className="folder-column">
										<div>
											<span className="status green-3 mb-2">
												24 Styles found in this location
											</span>
											<p className="regular-12 gray_dark_02 mt-1">
												BD:<span className="gray_dark_01"> 110304 </span>
											</p>
											<p className="regular-14 gray_dark_02 mt-1">
												BD, Lorenzo, F2, R1, Blue
												<span className="blue cursor-pointer ml-2">Edit</span>
											</p>
											<p className="regular-12 gray_dark_02 mt-2">
												Location ID:
												<span className="gray_dark_01 weight-700">32322</span>
												<span className="blue cursor-pointer ml-2 regular-14">
													Edit
												</span>
											</p>
											<span className="status yellow-2 mt-1">
												24 Styles found in this location
											</span>
											<div className="undo-btn d-block mt-2">
												<button className="button size32 outline">Undo</button>
											</div>
										</div>
									</td>
									<td></td>
								</tr>
								<tr>
									<td>1</td>
									<td className="scan-list-item-column">
										<div class="single-design-card d-flex align-items-center">
											<div className="card-top">
												<CommonImage
													src="/images/t-shirt-orange.png"
													alt=""
													class=""
												/>
											</div>

											<div className="card-content ml-12">
												<span className="status brown-2">Not found</span>
												<p class="regular-12 weight-500 gray_dark_01 my-1">
													MT24-A0493
												</p>
												<p class="text-underline regular-12 gray_dark_01 cursor-pointer">
													Tag & Comment
												</p>
												<p className="regular-12 gray_dark_02 mt-1">
													BD:<span className="gray_dark_01"> 110304 </span>
												</p>
												<ul class="common-list-component mt-1">
													<li>
														<span class="mb-0 semibold-12">P:$14.57</span>
													</li>
												</ul>
											</div>
										</div>
									</td>
									<td className="action-column">
										<CommonImage src="/icons/trash.svg" className="cursor-pointer" />
									</td>
								</tr>
								<tr>
									<td>1</td>
									<td className="scan-list-item-column">
										<div class="single-design-card d-flex align-items-center">
											<div className="card-top">
												<CommonImage
													src="/images/t-shirt-orange.png"
													alt=""
													class=""
												/>
											</div>

											<div className="card-content ml-12">
												<span className="status brown-2">Not found</span>
												<p class="regular-12 weight-500 gray_dark_01 my-1">
													MT24-A0493
												</p>
												<p class="text-underline regular-12 gray_dark_01 cursor-pointer">
													Tag & Comment
												</p>
												<p className="regular-12 gray_dark_02 mt-1">
													BD:<span className="gray_dark_01"> 110304 </span>
												</p>
												<ul class="common-list-component mt-1">
													<li>
														<span class="mb-0 semibold-12">P:$14.57</span>
													</li>
												</ul>
											</div>
										</div>
									</td>
									<td className="action-column">
										<CommonImage src="/icons/trash.svg" className="cursor-pointer" />
									</td>
								</tr>
								<tr>
									<td>1</td>
									<td className="scan-list-item-column">
										<div class="single-design-card d-flex align-items-center">
											<div className="card-top">
												<CommonImage
													src="/images/t-shirt-orange.png"
													alt=""
													class=""
												/>
											</div>

											<div className="card-content ml-12">
												<span className="status brown-2">Not found</span>
												<p class="regular-12 weight-500 gray_dark_01 my-1">
													MT24-A0493
												</p>
												<p class="text-underline regular-12 gray_dark_01 cursor-pointer">
													Tag & Comment
												</p>
												<p className="regular-12 gray_dark_02 mt-1">
													BD:<span className="gray_dark_01"> 110304 </span>
												</p>
												<ul class="common-list-component mt-1">
													<li>
														<span class="mb-0 semibold-12">P:$14.57</span>
													</li>
												</ul>
											</div>
										</div>
									</td>
									<td className="action-column">
										<CommonImage src="/icons/trash.svg" className="cursor-pointer" />
									</td>
								</tr>
								<tr>
									<td>1</td>
									<td className="scan-list-item-column">
										<div class="single-design-card d-flex align-items-center">
											<div className="card-top">
												<CommonImage
													src="/images/t-shirt-orange.png"
													alt=""
													class=""
												/>
											</div>

											<div className="card-content ml-12">
												<span className="status brown-2">Not found</span>
												<p class="regular-12 weight-500 gray_dark_01 my-1">
													MT24-A0493
												</p>
												<p class="text-underline regular-12 gray_dark_01 cursor-pointer">
													Tag & Comment
												</p>
												<p className="regular-12 gray_dark_02 mt-1">
													BD:<span className="gray_dark_01"> 110304 </span>
												</p>
												<ul class="common-list-component mt-1">
													<li>
														<span class="mb-0 semibold-12">P:$14.57</span>
													</li>
												</ul>
											</div>
										</div>
									</td>
									<td className="action-column">
										<CommonImage src="/icons/trash.svg" className="cursor-pointer" />
									</td>
								</tr>
								<tr>
									<td>1</td>
									<td className="scan-list-item-column">
										<div class="single-design-card d-flex align-items-center">
											<div className="card-top">
												<CommonImage
													src="/images/t-shirt-orange.png"
													alt=""
													class=""
												/>
											</div>

											<div className="card-content ml-12">
												<span className="status brown-2">Not found</span>
												<p class="regular-12 weight-500 gray_dark_01 my-1">
													MT24-A0493
												</p>
												<p class="text-underline regular-12 gray_dark_01 cursor-pointer">
													Tag & Comment
												</p>
												<p className="regular-12 gray_dark_02 mt-1">
													BD:<span className="gray_dark_01"> 110304 </span>
												</p>
												<ul class="common-list-component mt-1">
													<li>
														<span class="mb-0 semibold-12">P:$14.57</span>
													</li>
												</ul>
											</div>
										</div>
									</td>
									<td className="action-column">
										<CommonImage src="/icons/trash.svg" className="cursor-pointer" />
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
				<div className="scanner-footer  align-items-center flex-direction-column justify-content-end d-none">
					<div className="option">
						<button
							className="button size32 outline mr-2 dropdown-toggle"
							type="button"
							id="menu1"
							data-toggle="dropdown"
							aria-expanded="false"
						>
							More
						</button>
						<ul
							className="dropdown-menu-bottom shadow-lg pb-4"
							role="menu"
							aria-labelledby="menu1"
							x-placement="bottom-end"
						>
							<h5 className="more-action-title d-flex justify-content-between border-bottom">
								<span className="semibold-14 gray_dark_01">More Action</span>
								<span>
									<CommonImage
										src="/icons/close.svg"
										width={24}
										height={24}
										className="cursor-pointer"
									/>
								</span>
							</h5>
							<li role="presentation">
								<span
									role="menuitem"
									className="regular-14 gray_dark_02 gray-dark-02 d-block px-3 py-2"
								>
									Update Location
								</span>
							</li>
							<li role="presentation">
								<span
									role="menuitem"
									className="regular-14 gray_dark_02 gray-dark-02 d-block  px-3 py-2"
								>
									Download TP Summary
								</span>
							</li>
							<li role="presentation">
								<span
									role="menuitem"
									className="regular-14 gray_dark_02 gray-dark-02 d-block  px-3 py-2"
								>
									Add Tag & comments (Multiple styles)
								</span>
							</li>
						</ul>
					</div>
					<button className="button size32">Add to favourite</button>
				</div>
			</div>
		</>
	);
};
export default ScanSidebar;
